import { SetStateAction, Dispatch, useEffect } from 'react';
import {
  DevHubGrid,
  DevHubMenuItem,
  DevHubTextField,
} from '@devxdiscover/devhub-ui';
import { AppDetails, CorporateEntityProps } from './types/onboardingTypes';

interface Props {
  formData: AppDetails;
  setFormData: Dispatch<SetStateAction<AppDetails>>;
  setEntityDetail: Dispatch<SetStateAction<any>>;
  setValidationHasError: Dispatch<SetStateAction<boolean>>;
}

/**
 * Form to select entity for new app creation
 * @param props - The properties passed to the component.
 * @public
 */
export const AppCreationCorporateEntity = (props: Props) => {
  const { formData, setFormData, setEntityDetail } = props;

  const handleEntitySelection = (value: string) => {
    setFormData({ ...formData, entity: value });
    const selectedEntity = CorporateEntityProps.find(
      entity => entity.name === value,
    );
    setEntityDetail(selectedEntity);
  };

  useEffect(() => {
    if (
      !CorporateEntityProps.some(entity => entity.name === formData?.entity)
    ) {
      props.setValidationHasError(true);
    } else {
      props.setValidationHasError(false);
    }
  }, [formData?.entity]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <DevHubGrid container>
        <DevHubGrid item md={12} lg={6}>
          <DevHubTextField
            size="medium"
            variant="outlined"
            select
            name="corporateEntity"
            label="Corporate Entity"
            onChange={event => handleEntitySelection(event.target.value)}
            value={
              CorporateEntityProps.some(
                entity => entity.name === formData?.entity,
              )
                ? formData.entity
                : ''
            }
            helperText="Comcast business owner of the application"
            required
          >
            {CorporateEntityProps.map(entityOption => (
              <DevHubMenuItem key={entityOption.name} value={entityOption.name}>
                {entityOption.displayName}
              </DevHubMenuItem>
            ))}
          </DevHubTextField>
        </DevHubGrid>
      </DevHubGrid>
    </>
  );
};
